import React, { useCallback, useState } from 'react';
import toast from 'react-hot-toast';
import { translate } from '@utils/i18n';
import { Button, Text } from '@ui';
import { useAssessmentRating } from '../../hooks/useAssessmentRating';
import AssessmentFeedbackModal from '../AssessmentFeedbackModal';
import './AssessmentFeedbackStyles.scss';
const NS = 'features.iim_review.ai_summary_banner.feedback';
const BASE_CLASS = 'assessment-feedback';
export default function AssessmentFeedback({ assessmentId }) {
    const { vote, mutate, isLoading: isSubmitting } = useAssessmentRating(assessmentId);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const submitVote = useCallback((rating, reasonCode, details) => {
        mutate({ rating, reasonCode, details }, {
            // TODO(design): error copy is pending design review
            onError: () => {
                toast.error(translate('submit_error', {
                    namespace: NS,
                    defaultValue: 'Could not save your feedback. Please try again.'
                }));
            }
        });
    }, [mutate]);
    function handleThumbClick(clicked) {
        if (isSubmitting)
            return;
        if (vote === clicked) {
            submitVote(null);
            return;
        }
        if (clicked === 'down') {
            setIsModalOpen(true);
            return;
        }
        submitVote('up');
    }
    const handleModalSubmit = useCallback((reasonCode, details) => {
        setIsModalOpen(false);
        submitVote('down', reasonCode, details);
    }, [submitVote]);
    const handleModalClose = useCallback(() => {
        setIsModalOpen(false);
    }, []);
    return (React.createElement("div", { className: "assessment-feedback" },
        React.createElement(Text, { variant: "body", as: "span", className: "assessment-feedback__prompt" }, translate('prompt', { namespace: NS, defaultValue: 'Was this analysis helpful?' })),
        React.createElement(Button, { className: `${BASE_CLASS}__thumb ${vote === 'up' ? `${BASE_CLASS}__thumb--active` : ''}`, onClick: () => handleThumbClick('up'), disabled: isSubmitting, "aria-label": translate('thumbs_up', { namespace: NS }), "aria-pressed": vote === 'up' },
            React.createElement("i", { className: vote === 'up' ? 'fa-solid fa-thumbs-up' : 'fa-light fa-thumbs-up', "aria-hidden": "true" })),
        React.createElement(Button, { className: `${BASE_CLASS}__thumb ${vote === 'down' ? `${BASE_CLASS}__thumb--active` : ''}`, onClick: () => handleThumbClick('down'), disabled: isSubmitting, "aria-label": translate('thumbs_down', { namespace: NS }), "aria-pressed": vote === 'down' },
            React.createElement("i", { className: vote === 'down' ? 'fa-solid fa-thumbs-down' : 'fa-light fa-thumbs-down', "aria-hidden": "true" })),
        React.createElement(AssessmentFeedbackModal, { isOpen: isModalOpen, onClose: handleModalClose, onSubmit: handleModalSubmit })));
}
